import { render } from "./PreviewImageModal.vue?vue&type=template&id=10fbcb0c&scoped=true"
import script from "./PreviewImageModal.vue?vue&type=script&lang=js"
export * from "./PreviewImageModal.vue?vue&type=script&lang=js"

import "./PreviewImageModal.vue?vue&type=style&index=0&id=10fbcb0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10fbcb0c"]])

export default __exports__